import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { postRequest } from '../../../../lib/api';
import {toast} from 'react-hot-toast';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs'
import {Button} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const EditCustomLeadFee = () => {
  const { id } = useParams(); // Get ID from URL
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    product: '',
    name: '',
    net: 0,
    tax_exempt: false,
    is_optional: false,
    isActive: true,
  });

  const [productList, setProductList] = useState([]);

  // Fetch both single fee & product list
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [feeRes, productRes] = await Promise.all([
          postRequest(`private/getSingleCustomLeadFee/${id}`),
          postRequest('private/GetProducts'),
        ]);

        console.log(feeRes , 'feeRes')

        if (feeRes?.data) {
          const fee = feeRes.data;
          setFormData({
            product: fee.product_id|| '',
            name: fee.title || '', // assuming "title" is stored as name
            net: fee.net || 0,
            tax_exempt: fee.tax_exempt || false,
            is_optional: fee.is_optional || false,
            isActive: fee.isActive || false,
          });
        }

        if (productRes?.data) {
          setProductList(productRes.data);
        }
      } catch (err) {
        console.error('Failed to fetch data:', err);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      title: formData.name,
      product_id: formData.product,
      net: Number(formData.net),
      tax_exempt: formData.tax_exempt,
      is_optional: formData.is_optional,
      isActive: formData.isActive,
    };

    try {
      const res = await postRequest(`private/editCustomLeadFee/${id}`, payload);
      if (res?.status == 200 ) {
       // toast('Lead fee updated')
       // alert('Lead Fee updated successfully!');
        navigate(-1);
      } else {
        //alert('Something went wrong.');
      }
    } catch (error) {
      console.error('Update failed:', error);
      //alert('Failed to update data.');
    }
  };

  return (
    <>
      <BreadcrumbsWrapper
                                                      items={[
                                                        { label: 'Dashboard', path: '/dashboard' },
                                                        { label: 'CustomLeadFees', path: '/custom/lead-fees' },
                                                        { label: 'CustomLeadFeesEdit', path: '' },
                                                      
                                                       
                                                      ]}
                                                    />
                                              <br></br>
                                                <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2 style={{ marginBottom: '20px' }}>Edit Custom Lead Fee</h2>

      <form onSubmit={handleSubmit}>
        {/* Product Dropdown */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Product</label>
          <select
            name="product"
            value={formData.product}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          >
            <option value="">Select Product</option>
            {productList.map((product) => (
              <option key={product._id} value={product._id}>
                {product.title}
              </option>
            ))}
          </select>
        </div>

        {/* Name */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />
        </div>

        {/* Net */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>Net</label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px' }}>£</span>
            <input
              type="number"
              name="net"
              value={formData.net}
              onChange={handleChange}
              style={{
                flex: 1,
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
              }}
            />
          </div>
        </div>

        {/* Checkboxes */}
        <div style={{ marginBottom: '10px' }}>
          <label>
            <input
              type="checkbox"
              name="tax_exempt"
              checked={formData.tax_exempt}
              onChange={handleChange}
              style={{ marginRight: '6px' }}
            />
            Tax Exempt? (VAT will not be applied)
          </label>
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label>
            <input
              type="checkbox"
              name="is_optional"
              checked={formData.is_optional}
              onChange={handleChange}
              style={{ marginRight: '6px' }}
            />
            Is Optional
          </label>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label>
            <input
              type="checkbox"
              name="isActive"
              checked={formData.isActive}
              onChange={handleChange}
              style={{ marginRight: '6px' }}
            />
            Is Active
          </label>
        </div>

        {/* Buttons */}
        <div>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              backgroundColor: '#888',
              color: '#fff',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              marginRight: '10px',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>

           <Button variant="contained" className='red-bg red-button text-capitalize'
            type="submit" >
                       Update
                      </Button>
        
        </div>
      </form>
    </div>
    </>
  
  );
};

export default EditCustomLeadFee;
